<template>
  <div class="admin customers">
    <AdminHeader />
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 row-header"> Customer </div>
        </div>
        <div class="scrolling-table" v-show="!loading">
          <template v-for="item in customers">
            <div
              class="row clickable"
              :key="item.id"
              v-show="item.active == !show_deleted"
              v-bind:class="{ selected: item == customer }"
              @click="_customerSelected(item)"
            >
              <div class="col-12">
                {{ item.name }}
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- TAB BUTTONS -->
      <div class="col-9">
        <div class="row">
          <div class="col-12 mb-1" v-if="customer">
            <button
              id="btn_customer_tab"
              @click="_showTab(1)"
              class="btn btn-plt"
              :class="tab === 1 ? 'selected active' : ''"
            >
              Customer
            </button>
            <span v-show="customer != null">
              <button
                id="btn_job_tab"
                @click="_showTab(2)"
                class="btn btn-plt"
                :class="tab === 2 ? 'selected active' : ''"
              >
                Jobs
              </button>
            </span>
            <span v-show="customer != null">
              <button
                id="btn_site_tab"
                @click="_showTab(3)"
                class="btn btn-plt"
                :class="tab === 3 ? 'selected active' : ''"
              >
                Sites
              </button>
            </span>
            <span v-show="customer != null">
              <button
                id="btn_plant_tab"
                @click="_showTab(4)"
                class="btn btn-plt"
                :class="tab === 4 ? 'selected active' : ''"
              >
                Plants
              </button>
            </span>
          </div>
        </div>
        
        <div class="row">
          <CustomerDetail
            :customer="customer"
            ref="customer_detail"
            class="col-12"
            v-show="tab == 1"
            @new="_new"
          />
          <NewCustomerModal
            ref="new_customer_modal"
            v-show="showNewCustomerModal"
            @close="_closeNewCustomerModal"
          />
          <ManageJobs
            :customer_id="customer != null ? customer.id : -1"
            class="col-12"
            v-show="customer != null && tab == 2"
          />
          <ManageSites
            :customer_id="customer != null ? customer.id : -1"
            class="col-12"
            v-show="customer != null && tab == 3"
            @site_selected="site_selected"
          />
          <ManagePlants
            :site_id="site_id"
            class="col-12"
            v-show="site != null && tab == 4"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <input type="checkbox" id="show_deleted" @click="_show_deleted" />
        <label for="show_deleted">Show Deleted</label>
      </div>
    </div>
  </div>
</template>

<script>
import AdminHeader from "@/components/admin/AdminHeader.vue";
import CustomerDetail from "@/components/admin/customer/CustomerDetail.vue";
import NewCustomerModal from "@/components/admin/customer/NewCustomerModal.vue";
import ManageSites from "@/components/admin/site/ManageSites.vue";
import ManagePlants from "@/components/admin/plant/ManagePlants.vue";
import ManageJobs from "@/components/admin/job/ManageJobs.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "Customers",
  data: () => ({
    customer: null,
    loading: false,
    tab: 1,
    show_deleted: false,
    site: null,
    site_id: -1,
    showNewCustomerModal: false,
  }),
  mounted() {
    this.$nextTick(() => {
      this.getCustomers();
      this.getSites();
      this.getPlants();
      this.getJobs();
      this.$refs.customer_detail.new_customer();
    });
  },
  computed: {
    ...mapState("customers", ["customers", "new_customer"]),
    ...mapState("sites", ["new_site"]),
  },
  watch: {
    site(new_value) {
      if (new_value != null) {
        this.$set(this, "site_id", new_value.id);
      } else {
        this.$set(this, "site_id", -1);
      }
    },
    new_customer(new_value) {
      this.customer = new_value;
      this.$refs.new_customer_modal.clear();
    },
    new_site(new_value) {
      this.site = new_value;
    },
  },
  methods: {
    ...mapActions("customers", ["getCustomers"]),
    ...mapActions("sites", ["getSites"]),
    ...mapActions("plants", ["getPlants"]),
    ...mapActions("jobs", ["getJobs"]),
    //...mapActions("customers", ["apiSaveCustomer", "apiCreateCustomer"]),
    _show_deleted() {
      this.show_deleted = !this.show_deleted;
    },
    _export_myob() {},
    site_selected(site) {
      this.site = site;
      if (site != null) {
        this.$set(this, "site_id", site.id);
      } else {
        this.$set(this, "site_id", -1);
      }
    },
    _new() {
      this.showNewCustomerModal = true;
    },
    _closeNewCustomerModal() {
      this.showNewCustomerModal = false;
    },
    _showTab(index) {
      this.tab = index;
    },
    _customerSelected(customer) {
      this.customer = customer;
      this.site = null;
    },
  },
  components: {
    AdminHeader,
    CustomerDetail,
    NewCustomerModal,
    ManageSites,
    ManagePlants,
    ManageJobs,
  },
};
</script>
